﻿import { YesNoUnknown } from "@nkr/enums/yes-no-unknown";
import { IDonorSearchMicrositeResult } from "./donor-search-microsite-result"; 
 
export interface IDonorSearchResult { 
    firstName: string, 
    lastName: string, 
    fullName: string, 
    alias: string, 
    hasNutcracker: YesNoUnknown
    gender: string, 
    address: string, 
    city: string, 
    state: string, 
    postalCode: string, 
    email: string, 
    phoneNumber: string, 
    birthDate: string, 
    age: number, 
    registrationDate: string, 
    donationDate: string, 
    registrationId: number, 
    isPrivateLabel: boolean, 
    microsite: IDonorSearchMicrositeResult, 
    donorId: number, 
    donorShieldDirectId: number, 
    watrRequestId: number, 
    followUpDonorId: number, 
    closeLoopSurgeryDateTime: string, 
    closeLoopEntityTypeId: number, 
    closeLoopEntityType: string, 
    closeLoopManualConfirmType: string, 
    identifier: string 
}